import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            热门推荐
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            精选全网热播影视，每日为你推荐不容错过的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 3 ? "lazy" : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer group">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/2 relative aspect-video lg:aspect-auto overflow-hidden">
                <img
                  src={cards[6].image}
                  alt={cards[6].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                    {cards[6].tag}
                  </span>
                </div>
              </div>
              <div className="lg:w-1/2 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="font-heading text-lg md:text-2xl font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {cards[6].title}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {cards[6].description}
                </p>
                <div className="mt-5">
                  <span className="inline-flex items-center gap-1.5 text-primary-600 font-medium text-sm cursor-pointer whitespace-nowrap">
                    立即观看
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}